module.exports = __webpack_public_path__ + "static/media/large-utility.16537a1e.svg";